<v2-card>
  <v2-card-header
    [opaque]="true"
    opaqueColor="primary-tint"
    subtitle="{{ 'Menu.Items.Choose1Option' | translate }}"
  >
    <v2-body-header-2-text color="darkest-grey" title>
      {{ 'Menu.Items.ItemSelection' | translate }}
    </v2-body-header-2-text>
  </v2-card-header>

  <ng-container
    *ngFor="let item of (orderMenuStore.selectedItemGroup$ | async)?.items; last as isLast"
  >
    <v2-list-tile
      class="sub-item"
      [ripple]="true"
      (click)="viewItemDetails(item)"
    >
      <v2-body-large-text
        title
        [color]="item.isDisabled ? 'inactive-grey' : 'darkest-grey'"
      >
        {{item.name}}
      </v2-body-large-text>
      <v2-row pre-trailing>
        <v2-unavailable-item-chip
          *ngIf="item.isUnavailableDueToAlcohol || !item.inStock"
          [isDisabled]="item.isDisabled"
          [inStock]="item.inStock"
        ></v2-unavailable-item-chip>

        <v2-body-large-text
          [color]="item.isDisabled ? 'inactive-grey' : 'darkest-grey'"
        >
          {{item.price | v2Currency}}
        </v2-body-large-text>
      </v2-row>

      <v2-icon
        trailing
        icon="disclosure-right"
        color="medium-grey"
        class="right-arrow-icon"
      ></v2-icon>
    </v2-list-tile>
    <v2-divider [inset]="true" *ngIf="!isLast"></v2-divider>
  </ng-container>
</v2-card>
